var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C11.64 0 15 3.36 15 7.5C15 11.6475 11.64 15 7.5 15C3.3525 15 0 11.6475 0 7.5C0 3.36 3.3525 0 7.5 0ZM10.3875 5.0325C10.47 4.77 10.23 4.5225 9.9675 4.605L6.1275 5.805C5.97 5.8575 5.8425 5.9775 5.7975 6.135L4.5975 9.9825C4.515 10.2375 4.7625 10.485 5.0175 10.4025L8.8425 9.2025C9 9.1575 9.1275 9.03 9.1725 8.8725L10.3875 5.0325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.cdd19fd5185af5aba9ac283e57d8d570.svg";
export { ForwardRef as ReactComponent };